import Keyboard, { KeyboardReactInterface } from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import "./scss/search.scss";
import React, { useEffect, useRef } from "react";
import Input from "../components/Input";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../api/axiosInstance";
import Header from "../components/Header";
import AlertModal from "../components/AlertModal";
import { rootReducer } from "../store/store";
import { useHistory } from "react-router-dom";
import {
  driver,
  driverReset,
  resInfo,
  resOneInfo
} from "../actions/authActions";
import {
  AlertType,
  alertType
} from "../types/CommonType";
import { AxiosError, AxiosResponse } from "axios";
import { ReservationResponseData } from "../types/ReservationTypes";
import ReservationService from "../api/ReservationService";
type AuthState = ReturnType<typeof rootReducer>;
const Search: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [searchTel, setSearchTel] = useState<string>("010");
  const keyboardRef = useRef<KeyboardReactInterface | null>(null);
  const [modalTitle, setModalTitle] = useState<string>("에약 조회 실패");
  const [modalContent, setModalContent] = useState<string>("");
  const [modalShow, setModalShow] = useState<boolean>(false);
  const kioskInfo = useSelector((state: AuthState) => state.store.kioskInfo);
  const driverPrev = useSelector((state: AuthState) => state.store.driver);
  const driverInfo = driverPrev && driverPrev.data;
  const product = useSelector((state: AuthState) => state.store.product);
  console.log("product", product);
  console.log("kioskInfo", kioskInfo);
  const onKeyPress = (button: string) => {
    if (button === "재입력") {
      setSearchTel("");
      keyboardRef.current?.clearInput();
    } else if (button === "지우기") {
      setSearchTel(searchTel.slice(0, -1));
    } else {
      if (searchTel.length >= 11) return false;
      setSearchTel(searchTel + button);
    }
  };
  const [alertInfo, setAlertInfo] = useState<AlertType>(alertType);

  const onClick: React.MouseEventHandler<HTMLButtonElement> = async () => {
    try{
      console.log(driverInfo);
      window.chrome.webview.postMessage({ reset: "reset" });

      dispathReset();
      if (!kioskInfo?.data.companyId) {
        setModalTitle("미지정 업체");
        setModalContent(
          "해당 키오스크의 업체가 지정 되지 않았습니다.<br/> 데스크에 문의 바랍니다."
        );
        setModalShow(true);
        return false;
      }
      await axiosInstance()
        .post(`/kiosk/ajaxSearchReservation.do`, {
          searchTel: formatPhoneNumber(searchTel),
          companyId: Number(kioskInfo?.data.companyId)
        })
        .then((res: AxiosResponse<ReservationResponseData>) => {
          console.log(res.data.list);
          if (res.data.status === 400) {
            setModalContent(res.data.resultMsg); 
            setModalShow(true);
          } else {
            dispatch(resInfo(res));
            console.log(res)
            window.chrome.webview.postMessage({ reset: "reset" });
            if (res.data.list.length > 1) {
              history.push("/reservationList");
            } else {
              if (res.data.list[0].reservationStatus === "00000") {
                setModalTitle("데스크로 문의해주세요.");
                setModalContent("예약 상태 확인이 필요합니다.");
                setModalShow(true);
                return false;
              }

              const minTime = takeOverTimeCheck(
                res.data.list[0].takeoverDtm as unknown as Date
              );
              if (minTime > 20) {
                setModalTitle("차량 대여시간 이전");
                setModalContent("차량 대여는 인수시간 20분전 부터 가능합니다.");
                setModalShow(true);
                return false;
              }
              if (res.data.list[0].dispatchCarId === 0) {
                setModalTitle("차량 미배정");
                setModalContent(
                  "차량이 배정 되지 못했습니다.데스크에 문의 바랍니다."
                );
                setModalShow(true);
                return false;
              }
              if (!res.data.list[0].exportLocationDetail) {
                setModalTitle("차량 준비중");
                setModalContent("차량이 준비중입니다. 잠시만 기다려주세요.");
                setModalShow(true);
                return false;
              }
              if (res.data.list[0].processType === "LOCK") {
                setModalTitle("현재 사용중");
                setModalContent("해당 예약건이 타 키오스크에서 사용중입니다.");
                setModalShow(true);
                return false;
              }

              ReservationService.processLock(
                res.data.list[0].companyId,
                res.data.list[0].reservationId,
                res.data.list[0].processLockVersion
              ).then((response) => {
                if(response.data.status === 200) {
                  console.log(response.data);

                  res.data.list[0].processLockVersion = response.data.data.processLockVersion;
                  dispatch(resOneInfo(res.data.list[0]));
                  history.push("/reservation");
                }
              });
            }
          }
        })
        .catch((error: AxiosError) => {
          console.error(error);
      });
    } catch(error){
      console.log(error);

      setAlertInfo({
          show: true,
          title: "키오스크 시스템 에러",
          content: "예약 정보 조회 에러가 발생했습니다.<br/>예약 조회를 다시 시도해주세요.",
          callback: () => window.location.reload()
      });
    }
  };

  const dispathReset = () => {
    dispatch({ type: "DRIVER_CLEAR" });
    dispatch(driverReset());
    dispatch({ type: "DRIVER" });
    dispatch({ type: "RESERVATION_ONE" });
    dispatch({ type: "PRODUCT" });
    dispatch({ type: "PRODUCT_RESET" });
    dispatch({ type: "CARINFO" });
  };

  const formatPhoneNumber = (phoneNumber: string) => {
    // 전화번호에서 하이픈(-)을 제외한 숫자만 추출
    const digits = phoneNumber.replace(/-/g, "");

    // 추출한 숫자를 원하는 포맷으로 변환
    const formattedPhoneNumber = digits.replace(
      /(\d{3})(\d{3,4})(\d{4})/,
      "$1-$2-$3"
    );

    return formattedPhoneNumber;
  };

  const takeOverTimeCheck = (takeoverDtm: Date) => {
    const nowDateTime = new Date();

    const takeoverDateTime = new Date(takeoverDtm);

    const timeDifferenceMs = takeoverDateTime.getTime() - nowDateTime.getTime();

    const timeDifferenceMin = Math.floor(timeDifferenceMs / (1000 * 60));
    return timeDifferenceMin;
  };

  const layout = {
    default: ["1 2 3", "4 5 6", "7 8 9", "지우기 0 재입력"]
  };

  return (
    <>
      <Header></Header>
      {modalShow && (
        <AlertModal
          onClose={() => {
            setModalShow(false);
          }}
          title={modalTitle}
          content={modalContent}
        ></AlertModal>
      )}
      {alertInfo.show && (
        <AlertModal
          onClose={() => {
            if (alertInfo.callback) {
              alertInfo.callback(); // 콜백 함수 호출
            } else setAlertInfo((prev) => ({ ...prev, show: false }));
          }}
          title={alertInfo.title}
          content={alertInfo.content}
        ></AlertModal>
      )}
      <div className="search-root">
        <div className="search-title-wrap">
          <h1>예약자 연락처를 입력하세요.</h1>
        </div>

        <div className="search-input-wrap">
          <Input
            type={"text"}
            className="input-type1"
            maxLength={11}
            placeholder=""
            onChange={(e) => {
              if (searchTel.length > e.target.maxLength)
                e.target.value = e.target.value.slice(0, e.target.maxLength);
            }}
            readOnly={true}
            value={formatPhoneNumber(searchTel)}
          ></Input>
        </div>
        <div style={{ height: "3%" }}></div>
        <div className="keyborad-wrap">
          <Keyboard
            keyboardRef={(r) => (keyboardRef.current = r)}
            layout={layout}
            display={{
              "{bksp}": "⌫"
            }}
            onChange={() => {}}
            onKeyPress={onKeyPress}
          />
        </div>

        <div className="btn-wrap">
          <button onClick={onClick}>검색</button>
        </div>
      </div>
    </>
  );
};
<input
  type="hidden"
  name="kioskOperation"
  id="kioskOperation"
  value="initReservationInfo"
></input>;
export default Search;
